import React from 'react';
import { Tooltip } from 'antd';
import s from './s.module.less';

interface Props {
    label: string;
    num: number;
    tip: string;
}

const SvgInfo = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="11" x2="12" y2="16" />
        <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
);

const SummaryCard = ({ label, num, tip }: Props) => (
    <div className={s.summaryCard}>
        <div className={s.summaryHead}>
            <span className={s.summaryLabel}>{label}</span>
            <Tooltip title={tip} overlayStyle={{ maxWidth: 260 }}>
                <span className={s.summaryInfo}>
                    <SvgInfo />
                </span>
            </Tooltip>
        </div>
        <span className={s.summaryNum}>{num}</span>
    </div>
);

export default SummaryCard;
